export default
{
    "krita.add": "Add",
    "krita.amount": "Amount",
    "krita.application.adminoffer": "Offer admin",
    "krita.application.amountsonapp": "Amounts on application",
    "krita.application.application": "Application",
    "krita.application.approve": "Approve",
    "krita.application.approveapplication": "Approve application?",
    "krita.application.buffer": "Buffer",
    "krita.application.cancelapplication": "Cancel application",
    "krita.application.capital": "Capital",
    "krita.application.claimaccountnumber": "Claim account number",
    "krita.application.claimant": "Claimant",
    "krita.application.claimsinapp": "Claims in application",
    "krita.application.dateoffer": "Offer date",
    "krita.application.duedate": "Due Date",
    "krita.application.expirationdate": "Expiration date",
    "krita.application.factoringduedate": "Factoring due date",
    "krita.application.feeamount": "Fee amount",
    "krita.application.initafterref": "Initial transfer after refactoring",
    "krita.application.initialtransfer": "Initial Transfer",
    "krita.application.initialtransferamount": "Initial transfer amount",
    "krita.application.initwithoutrefres": "Initial transfer without refactoring reserve",
    "krita.application.modal.cancel": "Cancel",
    "krita.application.modal.remove": "Remove",
    "krita.application.modal.removetext": "Removing factoring from application will automatically set it to status NEW and will issue a new offer request from admin.",
    "krita.application.modal.text": "Are you sure you want to cancel this application?",
    "krita.application.originalcapital": "Original capital",
    "krita.application.refactored": "Refactored",
    "krita.application.registryid": "Claimant Registry Id",
    "krita.application.removefactoring": "Remove factoring from application",
    "krita.application.reservedforref": "Reserved for refactoring",
    "krita.application.status.canceled": "Canceled",
    "krita.application.status.completed": "Completed",
    "krita.application.status.new": "New",
    "krita.application.status.pending": "Pending",
    "krita.application.status.processing": "Processing",
    "krita.application.totalofferamount": "Total offer amount",
    "krita.applicationdetail": "Application detail",
    "krita.applicationdetail.header.home": "Application detail",
    "krita.bankclaim.status.canceled": "Canceled",
    "krita.bankclaim.status.legalcollection": "Legal collection",
    "krita.bankclaim.status.paid": "Paid",
    "krita.bankclaim.status.returned": "Returned",
    "krita.bankclaim.status.secondarycollection": "Secondary collection",
    "krita.bankclaim.status.unpaid": "Unpaid",
    "krita.cancel": "Cancel",
    "krita.claims.add": "Add",
    "krita.claims.additems": "Add items",
    "krita.claims.all": "All",
    "krita.claims.applicationsinprogress": "Applications in progress",
    "krita.claims.availableclaims": "Available claims",
    "krita.claims.capital": "Capital",
    "krita.claims.clear": "Clear",
    "krita.claims.createapplication": "Create application",
    "krita.claims.createrepayment": "Create repayment",
    "krita.claims.debtornamekennitala": "Debtor name & kennitala",
    "krita.claims.duedate": "Due date",
    "krita.claims.factoredclaims": "Active factorings",
    "krita.claims.factoringduedate": "Factoring due date",
    "krita.claims.faktor": "Factor",
    "krita.claims.faktorclaims": "Faktor claims",
    "krita.claims.faktormodal.part1": "You are faktoring",
    "krita.claims.faktormodal.part2": "claims in the amount of",
    "krita.claims.faktormodal.part3": "Length of the financing is from and to the final due date of each claim with added 4 days. When your offer has been processed you will receive an email.",
    "krita.claims.finalduedate": "Final due date",
    "krita.claims.header": "Claims",
    "krita.claims.header.home": "Home",
    "krita.claims.id": "Id",
    "krita.claims.items": "Items",
    "krita.claims.lefttopay": "Left to pay",
    "krita.claims.namekennitala": "Name & Kennitala",
    "krita.claims.nodata": "No data available",
    "krita.claims.overdue": "Overdue",
    "krita.claims.overduefactorings": "Active factorings",
    "krita.claims.pastduedate": "Past due date",
    "krita.claims.repay": "Repay",
    "krita.claims.repayfactoring": "Repay factorings",
    "krita.claims.repaymodal,part1": "Create repayment for ",
    "krita.claims.repaymodal.part1": "Create repayment for ",
    "krita.claims.repaymodal.part2": "factorings in the amount of",
    "krita.claims.repaymodal.part3": "A claim in the home bank will be created right away that you need to pay in order to settle the selected factorings.",
    "krita.claims.soon": "Soon",
    "krita.claims.status": "Status",
    "krita.claims.total": "Total",
    "krita.claims.unfactoredclaims": "Unfactored claims",
    "krita.close": "Close",
    "krita.datagrid.nodata": "No data available",
    "krita.datepick.enddate": "To",
    "krita.datepick.startdate": "From",
    "krita.factoring.account": "Account",
    "krita.factoring.alreadypaid": "Already paid amount",
    "krita.factoring.alreadypaidhelp": "Amount paid to this factoring in total, penalties included",
    "krita.factoring.amountsonfac": "Amounts",
    "krita.factoring.applicationid": "Application Id",
    "krita.factoring.bankclaiminfo": "Bank claim info",
    "krita.factoring.batchid": "Batch Id",
    "krita.factoring.bufferallocation": "Buffer allocation",
    "krita.factoring.capital": "Capital",
    "krita.factoring.claimantname": "Claimant name",
    "krita.factoring.claimantregistryid": "Claimant registry Id",
    "krita.factoring.created": "Created",
    "krita.factoring.currentbuffer": "Current buffer",
    "krita.factoring.currentbufferhelp": "Amount Krita keeps until repayment of the claim to cover eventual debts of claimant",
    "krita.factoring.date": "Date",
    "krita.factoring.debtorname": "Debtor name",
    "krita.factoring.debtorregistryid": "Debtor registry Id",
    "krita.factoring.duedate": "Due date",
    "krita.factoring.facduedate": "Factoring due date",
    "krita.factoring.feeamount": "Fee amount",
    "krita.factoring.feehelp": "The cost of factoring",
    "krita.factoring.finalduedate": "Final due date",
    "krita.factoring.generalinfo": "General info",
    "krita.factoring.id": "Id",
    "krita.factoring.identifier": "Identifier",
    "krita.factoring.initamounthelp": "Amount Krita sends to claimant for this factoring after successful factoring",
    "krita.factoring.initialamount": "Initial Transfer Amount",
    "krita.factoring.matching": "Matching",
    "krita.factoring.offerdate": "Offer date",
    "krita.factoring.originalcapital": "Original capital",
    "krita.factoring.paymentsource.feerepayment": "Fee repayment",
    "krita.factoring.paymentsource.inkassomanual": "Collection company manual",
    "krita.factoring.paymentsource.manual": "Manual",
    "krita.factoring.paymentsource.querybank": "Query bank",
    "krita.factoring.paymentsource.refactoring": "Refactoring",
    "krita.factoring.paymentsource.repayment": "Repayment",
    "krita.factoring.paymentsource.settling": "Settling",
    "krita.factoring.paymentstofactoring": "Payments to factoring",
    "krita.factoring.payorregistryid": "Payor registry Id",
    "krita.factoring.penaltyinterest": "Current penalty interest",
    "krita.factoring.penaltyinterestamount": "Penalty interest amount",
    "krita.factoring.penaltyinteresthelp": "Current penalty interest for late repaying of the factoring",
    "krita.factoring.remainingamount": "Remaining amount",
    "krita.factoring.remainingamounthelp": "How much claimant owes to Krita for this factoring.",
    "krita.factoring.repaymentdate": "Repayment date",
    "krita.factoring.source": "Source",
    "krita.factoring.status.alterfailed": "Altering claim identifier process failed",
    "krita.factoring.status.alterinit": "Altering claim identifier process initiated",
    "krita.factoring.status.altersucceed": "Altering claim identifier process succeeded",
    "krita.factoring.status.canceled": "Canceled",
    "krita.factoring.status.new": "New",
    "krita.factoring.status.pending": "Pending",
    "krita.factoring.status.repaid": "Repaid",
    "krita.factoring.status.repaidduringprocess": "Repaid during factoring process",
    "krita.factoring.status.repaidoutofsystem": "Repaid out of system",
    "krita.factoring.status.unpaid": "Unpaid",
    "krita.factoring.transfersout": "Transfers out",
    "krita.factoring.transferstatus.applicationcompletion": "Application completion",
    "krita.factoring.transferstatus.factoringbufferreturn": "Factoring buffer return",
    "krita.factoring.transferstatus.nonstandart": "Non standart",
    "krita.factoring.transferstatus.overpayment": "Overpayment",
    "krita.factoring.transfertrigger": "Transfer trigger",
    "krita.factoring.underlyingamount": "Amount on underlying bank claim at the moment of factoring' ",
    "krita.factoringdetail": "Factoring detail",
    "krita.factoringdetail.header.home": "Factoring detail",
    "krita.faktoring": "Factoring",
    "krita.home": "Home",
    "krita.indicator.overdue": "Overdue",
    "krita.indicator.due": "Overdue",
    "krita.indicator.soon": "Soon",
    "krita.language": "Language",
    "krita.language.english": "English",
    "krita.language.icelandic": "Icelandic",
    "krita.login.header": "Login",
    "krita.login.label.password": "Password",
    "krita.login.label.user": "Username",
    "krita.login.lable.user": "Username",
    "krita.login.loginaction": "Log in",
    "krita.login.passtrough": "Authenticating ...",
    "krita.login-remember": "Remember login",
    "krita.menu.claims": "Claims",
    "krita.menu.logout": "Log out",
    "krita.menu.reports": "Reports",
    "krita.neco": "neco",
    "krita.notification.factoringcreated": "Application sent",
    "krita.notification.loginfailed": "Login failed",
    "krita.notification.loginfailedgetuserinfo": "Login failed",
    "krita.ok": "OK",
    "krita.remove": "Remove",
    "krita.reports.application.filter.all": "All",
    "krita.reports.application.filter.completed": "Completed",
    "krita.reports.application.filter.inprogress": "In progress",
    "krita.reports.application.filter.labelcreated": "Created",
    "krita.reports.application.header.capital": "Capital",
    "krita.reports.application.header.created": "Created",
    "krita.reports.application.header.id": "Id",
    "krita.reports.application.header.initialtransferamount": "Initial transfer amount",
    "krita.reports.application.header.numberofclaims": "Count",
    "krita.reports.application.header.status": "Status",
    "krita.reports.applications": "Applications",
    "krita.reports.factorings.filter.all": "All",
    "krita.reports.factorings.filter.labelcreated": "Created",
    "krita.reports.factorings.filter.labeldue": "Due",
    "krita.reports.factorings.filter.pastduedate": "Past due date",
    "krita.reports.factorings.filter.repaid": "Repaid",
    "krita.reports.factorings.filter.unpaid": "Unpaid",
    "krita.reports.factorings.header.account": "Account",
    "krita.reports.factorings.header.account'": "Account",
    "krita.reports.factorings.header.capital": "Capital",
    "krita.reports.factorings.header.created": "Created",
    "krita.reports.factorings.header.debtorinfo": "Debtor",
    "krita.reports.factorings.header.debtorname": "Debtor name",
    "krita.reports.factorings.header.debtorregistryid": "Debtor registry Id",
    "krita.reports.factorings.header.factoringduedate": "Factoring due date",
    "krita.reports.factorings.header.id": "Id",
    "krita.reports.factorings.header.initialtransferamount": "Initial transfer amount",
    "krita.reports.factorings.header.lefttopay": "Left to pay",
    "krita.reports.factorings.header.status": "Status",
    "krita.reports.factorings.tabheader": "Factorings",
    "krita.reports.faktorings": "Factorings",
    "krita.reports.header.home": "Reports",
    "krita.reports.transfers.tabheader": "Transfers",
    "krita.status": "Status",
    "krita.repayment.status.new": "New",
    "krita.repayment.bankclaiminfo": "Bank claim info",
    "krita.reports.repayments.filter.new": "New",
    "krita.reports.repayments.filter.paid": "Paid",
    "krita.reports.repayments.filter.canceled": "Canceled",
    "krita.reports.repayments.filter.all": "All",
    "krita.reports.repayments.filter.legal": "Legal",
    "krita.reports.repayments.filter.repayment": "Repayment",
    "krita.reports.repayments.header.id": "Id",
    "krita.reports.repayments.header.debtor": "Debtor",
    "krita.reports.repayments.header.factoringcount": "Factoring count",
    "krita.reports.repayments.header.amount": "Amount",
    "krita.reports.repayments.header.type": "Type",
    "krita.reports.repayments.header.status": "Status",
    "krita.reports.repayments.header.createdby": "Created by",
    "krita.reports.repayments.header.expirationdate": "Expiration date",
    "krita.reports.repayments.header.created": "Created",
    "krita.reports.repayments.tabheader": "Repayments",
    "krita.reports.summaryreport.tabheader": "Summary",
    "krita.repayment.amountsonrepayment": "Amounts on repayment",
    "krita.repayment.status.cancelled": "Cancelled",
    "krita.repayment.debtorname": "Debtor name",
    "krita.repayment.debtorid": "Debtor id",
    "krita.repayment.expirationdate": "Expiration date",
    "krita.repayment.created": "Created",
    "krita.repayment.createdby": "Created by",
    "krita.repayment.type": "Type",
    "krita.repayment.capital": "Capital",
    "krita.repayment.currpenaltyinterest": "Current penalty interest",
    "krita.repayment.total": "Total",
    "krita.repayment.debtorregistryid": "Debtor registry id",
    "krita.repayment.account": "Account",
    "krita.repayment.duedate": "Due date",
    "krita.repayment.finalduedate": "Final due date",
    "krita.repayment.factorings": "Factorings",
    "krita.repayment.history": "History",
    "krita.repaymentdetail.history.header.status": "Status",
    "krita.repaymentdetail.history.header.debtor": "Debtor name & kennitala",
    "krita.repaymentdetail.history.header.expirationdate": "Expiration date",
    "krita.repaymentdetail.history.header.capital": "Capital",
    "krita.repaymentdetail.history.header.penaltyamount": "Penalty amount",
    "krita.repaymentdetail.history.header.modified": "Modified",
    "krita.repaymentdetail.history.header.modifiedby": "Modified by",
    "krita.repaymentdetail.history.header.action": "Action",
    "krita.repaymentdetail.factoring.header.id": "Id",
    "krita.repaymentdetail.factoring.header.debtor": "Debtor name & kennitala",
    "krita.repaymentdetail.factoring.header.status": "Status",
    "krita.repaymentdetail.factoring.header.factoringduedate": "Factoring due date",
    "krita.repaymentdetail.factoring.header.capital": "Capital",
    "krita.repaymentdetail.factoring.header.lefttopay": "Left to pay",
    "krita.repaymentdetail.factoring.header.account": "Account",
    "krita.repaymentdetail.factoring.header.initialtransferamount": "Initial transfer amount",
    "krita.repaymentdetail.factoring.header.created": "Created",
    "krita.action.insert": "Insert",
    "krita.action.update": "Update",
    "krita.repayment.type.repayment": "Repayment",
    "krita.repayment.type.legal": "Legal",
    "krita.repaymentdetail.header.home": "Repayment detail",
    "krita.transfers.all": "All",
    "krita.transfers.repayments": "Repayments",
    "krita.transfers.applications": "Applications",
    "krita.transfers.factorings": "Factorings",
    "krita.reports.transfers.header.reference": "Reference",
    "krita.reports.transfers.header.amount": "Amount",
    "krita.reports.transfers.header.transferdate": "Transfer date",
    "krita.reports.transfers.header.type": "Type",
    "krita.reports.transfers.header.id": "Id",
    "krita.reports.transfers.header.created": "Created",
    "krita.repayment.status.paid": "Paid",
    "krita.notification.repaymentcreated": "Repayment created",
    "krita.datagrids.nodata": "No data",
    "krita.common.debtor": "Debtor",
    "krita.common.account": "Account",
    "krita.common.capital": "Capital",
    "krita.common.dueDate": "Due date",
    "krita.common.finalDueDate": "Final due date",
    "krita.common.status": "Status",
    "krita.common.bankClaimInfo": "Bank claim info",
    "krita.notification.error.getExcelSummaryReport": "Failed to get summary report",
    "krita.factoring.duration": "Duration (days)",
    "krita.factoring.bufferAmount": "Buffer amount",
    "krita.factoring.apr": "APR",
    "krita.factoring.otherInfo": "Other info",
    "krita.factoring.unpaidCapital": "Remaining capital",
    "krita.factoring.unpaidFee": "Remaining fee",
    "krita.common.id": "Id",
    "krita.common.facDueDate": "Factoring due date",
    "krita.common.paymentDate": "Payment date",
    "krita.transfers.bankClaims": "Bank Claims",
    "krita.common.true": "True",
    "krita.common.false": "False",
    "krita.common.all": "All",
    "krita.notification.error.unauthorized": "Unauthorized",
    "krita.notification.error.approveapplicationoffer": "Failed to approve application offer",
    "krita.notification.approveapplicationoffer": "Approve application offer",
    "krita.notification.cancelapplicationoffer": "Cancel application offer",
    "krita.notification.error.cancelapplicationoffer": "Failed to cancel application offer",
    "krita.notification.removesfactoringfromapplication": "Remove factoring from application",
    "krita.notification.error.removesfactoringfromapplication": "Failed to remove factoring from application",
    "krita.indictator.due" : "Due",
}